import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { timer } from 'rxjs';
import { OrderService } from 'src/app/core/services/order.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-orders',
  templateUrl: './modal-orders.component.html'
})
export class ModalOrdersComponent implements OnInit {
  orders:any = [];
  loading = true;
  constructor(public activeModal: NgbActiveModal,private orderService:OrderService) {    
    
  }

  async ngOnInit() {
    this.orders = await this.orderService.getOrdenesMesa();
    this.loading=false;
  }

  close(){
    this.activeModal.close();
  }

  passBack() {
    this.activeModal.close();
  }

  setOrder(order:any){
    this.orderService.setOrder(order);
    this.activeModal.close();
  }
}